define('NVT.AssociateMembershipForm.GlobalformAddress.View'
, [
      'Backbone'

    , 'nvt_mulitple_address_dynemic.tpl'

    , 'NVT.AssociateMembershipForm.AssoMembForm.SS2Model'

    , 'Backbone.FormView'

    , 'GlobalViews.Message.View'

    , 'underscore'

    , 'jQuery'

    , 'Utils'
    
  ]
, function
  (
        
    Backbone

    , nvt_mulitple_address_dynemic_tpl

    , AssoMembFormSS2Model

    , BackboneFormView

    , MessageView

    , _

    , jQuery

    , Utils    

  )
{
  'use strict';

    return Backbone.View.extend({
           
        template: nvt_mulitple_address_dynemic_tpl

    ,   title: Utils.translate('Contact')

    ,   initialize: function(options)
        {
            this.options = options;
            this.application = options.application;
            this.page_header = "Contact";	
            this.modalClass ='modal-md';  
            var self = this;
            BackboneFormView.add(this);
        }

    ,   events: 
        {
            'submit form': 'saveTheForm'
        }   
        
    ,   validateEmail : function (email) {
            var self = this;
            var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
            return re.test(email);
        }

    ,	getdesiglists: function () {
        var self = this;
        this.models = new AssoMembFormSS2Model();
            self.listbusinesssector = []

            this.models.fetch({async: false,data: {
                'getmethod':'getdesiglist'
                }}).done(function(result) {
                if(result)
                {
                    self.listbusinesssector = result;
                }				 
            });

        return self.listbusinesssector
    }

    ,   saveTheForm: function(e)
        {
            e.preventDefault();
            e.stopImmediatePropagation();

            var self = this,
                $target = jQuery(e.target),
                getfielddata = $target.serializeObject();
                
            if(!getfielddata.global_given_name)
            {
                self.showMessage('Given name is required', 'error','global_given_name');
                return false;
            }
            else if(!getfielddata.global_surname_name)
            {
                self.showMessage('Surname is required', 'error','global_surname_name');
                return false;
            }
            else if(!getfielddata.global_job_title )
            {
                self.showMessage('Job Title is required', 'error','global_job_title');
                return false;
            }
            else if(!getfielddata.global_business_email || !self.validateEmail(getfielddata.global_business_email))
            {
                self.showMessage('Email is required', 'error','global_business_email');
                return false;
            }
            else if (!getfielddata.global_business_telephone) {
                self.showMessage('Business telephone is required', 'error', 'global_business_telephone');
                return false;
            }
            else if(getfielddata.global_business_telephone.length < 8)
            {
                self.showMessage('A phone number is required. Please enter at least 8 digits.', 'error', 'global_business_telephone');
                return false;
            }
            else
            {
                for (let [i, addr] of self.options.globaladdresslist.entries()) {
                    if (addr.global_business_email === getfielddata.global_business_email) {
                        self.options.globaladdresslist.splice(i, 1);
                    }

                    if (addr.global_business_email === self.id) {
                        self.options.globaladdresslist.splice(i, 1);
                    }
                }
                          
                var getCurrentAddrvalue = {
                    'global_given_name':getfielddata.global_given_name,
                    'global_surname_name':getfielddata.global_surname_name,
                    'global_job_title':getfielddata.global_job_title,
                    'global_business_email':getfielddata.global_business_email,
                    'global_business_telephone':getfielddata.global_business_telephone,
                    'global_contact_category' : getfielddata.nus_contactdesignation || '',
                    'global_contact_category_text' : getfielddata.nus_contactdesignation ? jQuery("#in-modal-nus_contactdesignation option:selected").map(function () {return $(this).text();}).get().join(',') : ''

                }
              
                self.options.globaladdresslist.push(getCurrentAddrvalue);
                var promise = BackboneFormView.saveForm.apply(this,arguments);
            }                             
        }

    ,   showMessage: function(message, type, field)
        {
            jQuery('.global-views-message-error').remove(); 
            jQuery('.global-views-message-success').remove(); 

            var messageView = new MessageView
            ({
                    message: message
                ,   type: type
                ,   closable: type =='error' ? true : false
            });
            if (typeof field !== 'undefined')
            {
                this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
            }
            else if (type =='error'){
                this.application.getLayout().$('form').append(messageView.render().$el);
            }
            else
            {
                this.application.getLayout().$('form').empty().html(messageView.render().$el);       
                setTimeout(function() {
                    jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                }, 1000);
            }
        }    

    ,   getContext: function() {

            var self = this;
            var newgetdesglist = self.getdesiglists();
            var getdesgRemovelist = SC.CONFIGURATION.MyOrganisation.getDesignation || '';
                getdesgRemovelist= getdesgRemovelist.split(",") || [];
            if(newgetdesglist){
                newgetdesglist = newgetdesglist.filter(item => !getdesgRemovelist.includes(item.desgid));
            }

            return {
        
                title : this.title,

                continueDataFlow : this.options.globaladdresslistselected.length > 0 ? this.options.globaladdresslistselected[0] : '',

                getdesglist : newgetdesglist || '',
            }
        }        

    });

});
